/* eslint-disable prefer-template */

import { cartierDebug } from './Debug'

/**
 * loadPage
 *
 * @method
 * @description Load ControllerName script
 * @returns {Promise}
 */
export const loadPage = () => {
	const page = yTos.Cartier.controllerName.toLowerCase()

	return new Promise((resolve) => {
		import(
			/* webpackInclude: /\.js$/ */
			/* webpackExclude: /\.(tracking|utils|test)\.js$/ */
			/* webpackChunkName: "pages/[request]" */
			'../pages/' + page + '/' + page + '.js'
		)
			.then((module) => {
				resolve(module)
			})
			.catch((error) => {
				cartierDebug('info', error)
				resolve()
			})
	})
}

/**
 * loadWebComponents
 *
 * @method
 * @description Dinamically load all web-components js.
 * @param {Array.<string>} components
 * @param {boolean} shouldLoadOnlyExisting
 * @returns {Promise}
 */
export const loadWebComponents = (components, shouldLoadOnlyExisting = false) => {
	const loadedComponents = yTos.Cartier.componentsList.length
	const componentsToLoad = components
		? components.filter((x) => {
				if (!shouldLoadOnlyExisting) return yTos.Cartier.componentsList.indexOf(x) === -1
				return (
					yTos.Cartier.componentsList.indexOf(x) === -1 &&
					document.querySelector(x) !== null
				)
		  })
		: yTos.Cartier.componentsList && yTos.Cartier.componentsList.splice(0, loadedComponents)

	return new Promise((resolve) => {
		window.WebComponents.waitFor(() =>
			Promise.all(
				componentsToLoad.map((webComponent) => {
					yTos.Cartier.componentsList.push(webComponent)
					return import(
						/* webpackInclude: /\.js$/ */
						/* webpackExclude: /\.(tracking|utils|test)\.js$/ */
						/* webpackChunkName: "components/[request]" */
						'../components/' + webComponent + '/' + webComponent + '.js'
						// `../components/${webComponent}/${webComponent}`
						// due to a small bug we can't transpile template literals inside dynamic import
						// https://github.com/babel/babel/issues/9753
					)
				})
			)
				.then(() => {
					resolve()
				})
				.catch((error) => {
					cartierDebug('error', error)
					resolve()
				})
		)
	})
}
